import { Backdrop } from '@material-ui/core'
import { RouteComponentProps } from '@reach/router'
import { rgba } from 'polished'
import { useState } from 'react'
import { Box } from 'reoil'
import bg from '../assets/images/bg.jpg'
import bg2 from '../assets/images/bg2.svg'
import btnText from '../assets/images/btn-text.png'
import title2 from '../assets/images/title2.png'
import Login from '../components/Login'
import Navigation from '../components/Navigation'
import TabNav from '../components/TabNav'
import { palette } from '../theme'
import goto from '../utils/goto'

interface RoutePropsEx {
  location: {
    state: {
      requireLogin: boolean
    }
  }
}

const HomePage: React.FC<RouteComponentProps<RoutePropsEx>> = ({
  location = {state: {requireLogin: false}}
}) => {
  const requireLogin = location.state && location.state.requireLogin
  const [showLogin, setShowLogin] = useState(requireLogin || false)

  const handleClick = () => {
    goto('/jobs')
  }

  const handleLoginSuccess = (token: string) => {
    setShowLogin(false)
    window.history.replaceState(
      {...window.history.state, requireLogin: false},
      ''
    )
    goto(-1)
  }

  return (
    <Box className='HomePage' minHeight='100%' stretch bg={palette.grayblue}>
      <Box className='bg' position='absolute' size='100%' cover>
        <img src={bg} alt='' />
      </Box>

      <Box
        className='bg2'
        width='90%'
        fit='contain'
        maxWidth={378}
        position='absolute'
        right={0}
        bottom={0}>
        <img src={bg2} alt='' />
      </Box>

      <Box mt={50}></Box>

      <Navigation bg='' />
      <TabNav />

      <Box center flex={1}>
        <Box className='title1' maxWidth={326} fit='contain'>
          <img src={title2} alt='' />
        </Box>
        <Box className='title2' maxWidth={285} mt={4} fit='contain'>
          {/* <img src={title1} alt='' /> */}
          <Box
            color='white'
            fontWeight='bold'
            fontSize={5}
            style={{
              whiteSpace: 'nowrap',
              fontFamily: 'PingFangSC, sans-serif'
            }}>
            2022 校园招聘
          </Box>
        </Box>
        <Box
          pointer
          className='btn'
          bg='primary'
          width={287}
          height={63}
          center
          borderRadius={200}
          boxShadow={`0 20px 30px -5px ${rgba('#017FFF', 0.9)}`}
          mt={50}
          mb={6}
          onClick={handleClick}>
          <Box width={150} fit='contain'>
            <img src={btnText} alt='' />
          </Box>
        </Box>
      </Box>

      <Backdrop
        open={showLogin}
        style={{zIndex: 3000}}
        onClick={() => setShowLogin(!showLogin)}>
        <Login onSuccess={handleLoginSuccess} />
      </Backdrop>
    </Box>
  )
}

export default HomePage
